var _linearGradient, _clipPath, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlender(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71,
    height: 20,
    role: "img",
    "aria-label": "Blender",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Blender") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 71,
    height: 20,
    fill: "#f5792a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjZmZmZmZmIiByb2xlPSJpbWciIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+QmxlbmRlcjwvdGl0bGU+PHBhdGggZD0iTTEyLjUxIDEzLjIxNGMuMDQ2LS44LjQzOC0xLjUwNiAxLjAzLTIuMDA2YTMuNDI0IDMuNDI0IDAgMCAxIDIuMjEyLS43OWMuODUgMCAxLjYzMS4zIDIuMjExLjc5LjU5Mi41Ljk4MyAxLjIwNiAxLjAyOCAyLjAwNS4wNDUuODIzLS4yODUgMS41ODYtLjg2NSAyLjE1M2EzLjM4OSAzLjM4OSAwIDAgMS0yLjM3NC45MzggMy4zOTMgMy4zOTMgMCAwIDEtMi4zNzYtLjkzOGMtLjU4LS41NjctLjkxLTEuMzMtLjg2NS0yLjE1Mk03LjM1IDE0LjgzMWMuMDA2LjMxNC4xMDYuOTIyLjI1NiAxLjM5OGE3LjM3MiA3LjM3MiAwIDAgMCAxLjU5MyAyLjc1NyA4LjIyNyA4LjIyNyAwIDAgMCAyLjc4NyAyLjAwMSA4Ljk0NyA4Ljk0NyAwIDAgMCAzLjY2Ljc2IDguOTY0IDguOTY0IDAgMCAwIDMuNjU3LS43NzIgOC4yODUgOC4yODUgMCAwIDAgMi43ODUtMi4wMSA3LjQyOCA3LjQyOCAwIDAgMCAxLjU5Mi0yLjc2MiA2Ljk2NCA2Ljk2NCAwIDAgMCAuMjUtMy4wNzQgNy4xMjMgNy4xMjMgMCAwIDAtMS4wMTYtMi43NzkgNy43NjQgNy43NjQgMCAwIDAtMS44NTItMi4wNDNoLjAwMkwxMy41NjYgMi41NWwtLjAyLS4wMTVjLS40OTItLjM3OC0xLjMxOS0uMzc2LTEuODYuMDAyLS41NDcuMzgyLS42MDkgMS4wMTUtLjEyMyAxLjQxNWwtLjAwMS4wMDEgMy4xMjYgMi41NDMtOS41My4wMWgtLjAxM2MtLjc4OC4wMDEtMS41NDUuNTE4LTEuNjk1IDEuMTcyLS4xNTQuNjY1LjM4IDEuMjE3IDEuMiAxLjIyVjguOWw0LjgzLS4wMS04LjYyIDYuNjE3LS4wMzQuMDI1Yy0uODEzLjYyMi0xLjA3NSAxLjY1OC0uNTYzIDIuMzEzLjUyLjY2NyAxLjYyNS42NjggMi40NDcuMDA0TDcuNDE0IDE0cy0uMDY5LjUyLS4wNjMuODMxem0xMi4wOSAxLjc0MWMtLjk3Ljk4OC0yLjMyNiAxLjU0OC0zLjc5NSAxLjU1LTEuNDcuMDA0LTIuODI3LS41NTItMy43OTctMS41MzhhNC41MSA0LjUxIDAgMCAxLTEuMDM2LTEuNjIyIDQuMjgyIDQuMjgyIDAgMCAxIC4yODItMy41MTkgNC43MDIgNC43MDIgMCAwIDEgMS4xNTMtMS4zNzFjLjk0Mi0uNzY4IDIuMTQxLTEuMTgzIDMuMzk2LTEuMTg1IDEuMjU2LS4wMDIgMi40NTUuNDEgMy4zOTggMS4xNzUuNDguMzkxLjg3Ljg1NCAxLjE1MiAxLjM2N2E0LjI4IDQuMjggMCAwIDEgLjUyMiAxLjcwNiA0LjIzNiA0LjIzNiAwIDAgMS0uMjM5IDEuODExIDQuNTQgNC41NCAwIDAgMS0xLjAzNSAxLjYyNiIvPjwvc3ZnPg=="
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 445,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 430
  }, "Blender"), /*#__PURE__*/React.createElement("text", {
    x: 445,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 430
  }, "Blender"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlender);
export default __webpack_public_path__ + "static/media/blender.bbcb8c1f83d7beb72d02bf71298cc2a2.svg";
export { ForwardRef as ReactComponent };